/** Fixed operational palettes for field dispatch calendar — no arbitrary colors. */

export type FieldCalendarLaneKey = "service" | "installation" | "programming";

export const FIELD_CALENDAR_DEFAULT_LANE_COLORS: Record<FieldCalendarLaneKey, FieldCalendarLaneKey> = {
  service: "service",
  installation: "installation",
  programming: "programming",
};

/** Awareness layer (month/week dots and chips) */
export const FIELD_LANE_DOT: Record<string, string> = {
  service: "bg-orange-500",
  installation: "bg-emerald-500",
  programming: "bg-violet-500",
  others: "bg-slate-500",
  leave: "bg-sky-400",
  urgent: "bg-red-600",
  completed: "bg-slate-400",
};

/** Month/week readable chips */
export const FIELD_LANE_CHIP: Record<string, string> = {
  service: "bg-orange-500 text-white",
  installation: "bg-emerald-600 text-white",
  programming: "bg-violet-600 text-white",
  others: "bg-slate-600 text-white",
  urgent: "bg-red-600 text-white",
  completed: "bg-slate-300 text-slate-600",
  leave: "bg-sky-200 text-sky-950",
};

/** Dispatch timeline / execution panel fills */
export const FIELD_LANE_DISPATCH: Record<string, string> = {
  service: "bg-orange-100 border-l-4 border-l-orange-500 text-orange-950",
  installation: "bg-emerald-100 border-l-4 border-l-emerald-600 text-emerald-950",
  programming: "bg-violet-100 border-l-4 border-l-violet-600 text-violet-950",
  others: "bg-slate-200 border-l-4 border-l-slate-600 text-slate-900",
  urgent: "bg-red-600 border-l-4 border-l-red-900 text-white",
  completed: "bg-slate-100 border-l-4 border-l-slate-400 text-slate-600",
  leave: "bg-sky-100 border-l-4 border-l-sky-500 text-sky-950",
};

export const FIELD_LEGEND_ITEMS = [
  { key: "service", label: "Service", dot: FIELD_LANE_DOT.service },
  { key: "installation", label: "Installation", dot: FIELD_LANE_DOT.installation },
  { key: "programming", label: "Programming", dot: FIELD_LANE_DOT.programming },
  { key: "others", label: "Others", dot: FIELD_LANE_DOT.others },
  { key: "leave", label: "Leave", dot: FIELD_LANE_DOT.leave },
] as const;

export const FIELD_FILTER_DOT: Record<string, string> = {
  service: FIELD_LANE_DOT.service,
  installation: FIELD_LANE_DOT.installation,
  programming: FIELD_LANE_DOT.programming,
  all: "bg-blue-600",
};
